import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, Button, Card, CardContent } from '@metarouter-private/mr-mui';
import EnableDisableToggle from './EnableDisableToggle';
import EditEventTypes from './EditEventTypes';
import ReadOnlyEventTypes from './ReadOnlyEventTypes';
import EditUrlModal from './EditUrlModal';

export default function WebhookConfigDisplay({ webhookConfig, canWrite }) {
  const [editUrlOpen, setEditUrlOpen] = useState(false);
  const subscribedEventsKey = webhookConfig.webhookConfigEventSubscriptions.map(sub => sub.eventType).join(',');

  return (
    <>
      <Card variant="outlined">
        <CardContent>
          <Stack spacing={3}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="h6">Webhook Configuration</Typography>
              {canWrite && <EnableDisableToggle webhookConfig={webhookConfig} />}
              {!canWrite && (
                <Typography variant="body2" color={webhookConfig.enabledAt ? 'success.main' : 'text.secondary'}>
                  {webhookConfig.enabledAt ? 'Enabled' : 'Disabled'}
                </Typography>
              )}
            </Stack>

            <Stack spacing={1}>
              <Typography variant="subtitle2" color="text.secondary">
                Endpoint URL
              </Typography>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="body1">{webhookConfig.url}</Typography>
                {canWrite && (
                  <Button size="small" variant="outlined" onClick={() => setEditUrlOpen(true)}>
                    Edit
                  </Button>
                )}
              </Stack>
            </Stack>

            {canWrite && <EditEventTypes key={subscribedEventsKey} webhookConfig={webhookConfig} />}
            {!canWrite && <ReadOnlyEventTypes webhookConfig={webhookConfig} />}

            <Stack spacing={1}>
              <Typography variant="subtitle2" color="text.secondary">
                Signing Secret
              </Typography>
              <Typography variant="body2" color="text.secondary">
                The HMAC signing secret was shown at creation time and cannot be retrieved.
              </Typography>
            </Stack>
          </Stack>
        </CardContent>
      </Card>

      {canWrite && editUrlOpen && <EditUrlModal onClose={() => setEditUrlOpen(false)} webhookConfig={webhookConfig} />}
    </>
  );
}

WebhookConfigDisplay.propTypes = {
  webhookConfig: PropTypes.shape({
    id: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    enabledAt: PropTypes.string,
    webhookConfigEventSubscriptions: PropTypes.arrayOf(
      PropTypes.shape({
        eventType: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
  canWrite: PropTypes.bool.isRequired,
};
